module.exports = __webpack_public_path__ + "img/img_xuzhi.c14b96be.jpg";